import React from "react";

// MindConnect logo ("Double n", chosen 2026-10-29). It follows the NeuralLoom
// Labs logo's idea: that mark was the two "l"s of "neuralloom" as bars (first
// Loom Indigo, second Orven Teal); this one is the two "n"s of "connect" as
// arches, in the same two colours. The wordmark colours that "nn" to match.
// Same component as psych_nllabs_Web and psych_appointment_app_FE; keep them in step.

const COLORS = {
  light: { ink: '#1B1A2E', indigo: '#4B45A3', teal: '#3C9E95', sub: '#71717F' },
  dark: { ink: '#F1F3F5', indigo: '#8F8AD6', teal: '#57C7BC', sub: '#A6A6B1' },
};

// Square mark (navbar, footer, favicon) on a 24x24 grid.
export function MindConnectMark({ className = 'w-8 h-8', onDark = false }) {
  const c = onDark ? COLORS.dark : COLORS.light;
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path d="M3.6 18.4V9a3.2 3.2 0 0 1 6.4 0v9.4" stroke={c.indigo} strokeWidth="3.2" strokeLinecap="round" />
      <path d="M14 18.4V9a3.2 3.2 0 0 1 6.4 0v9.4" stroke={c.teal} strokeWidth="3.2" strokeLinecap="round" />
    </svg>
  );
}

// "mindconnect" in Manrope ExtraBold, lowercase, with the "nn" in the mark's colours.
export function MindConnectWordmark({ className = 'text-xl', onDark = false }) {
  const c = onDark ? COLORS.dark : COLORS.light;
  return (
    <span className={`font-heading font-extrabold lowercase tracking-tight whitespace-nowrap ${className}`} style={{ color: c.ink }}>
      mindco<span style={{ color: c.indigo }}>n</span><span style={{ color: c.teal }}>n</span>ect
    </span>
  );
}

// Small line under the wordmark so existing clients see it's the same company.
export function MindConnectTagline({ className = 'text-[8px]', onDark = false }) {
  const c = onDark ? COLORS.dark : COLORS.light;
  return (
    <span className={`block font-mono uppercase tracking-wider ${className}`} style={{ color: c.sub }}>
      by neuralloom labs
    </span>
  );
}
